export const INACTIVITY_TIMEOUT_MS = 5 * 60 * 1000;

export function createInactivityClock(
  timeoutMs: number = INACTIVITY_TIMEOUT_MS
) {
  let lastActivityTime: number | null = null;

  return {
    updateActivity() {
      lastActivityTime = Date.now();
    },

    getRemainingTime(): number | null {
      if (!lastActivityTime) {
        return null;
      }
      return Math.max(0, timeoutMs - (Date.now() - lastActivityTime));
    },

    isTimedOut(): boolean {
      if (!lastActivityTime) return false;
      return Date.now() - lastActivityTime >= timeoutMs;
    },

    reset() {
      lastActivityTime = null;
    },
  };
}
